// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1bdRA","left":"InfoRow_left__3d9lM"};